import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
import Footer from '../footer/footer'
import NavBar from '../navbar/Navbar'
import ErrorIMG from './errorIMG.png'



const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));
  
export default function Notfound() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <NavBar/>
            <Link id='back' to="/">
                <Button style={{ margin: '10px',marginTop:'80px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
        <Grid container spacing={3} style={{marginTop:'100px'}} justify="center">
          <Grid item xs={12} sm={12} md={6}>
            <Paper className={classes.paper} >
                <img src={ErrorIMG}/>
                <h2 style={{color:'black'}}>Come Back later.</h2>
            </Paper>
          </Grid>
         
        </Grid>
        <Footer />
      </div>
    )
}
